<template>
  <v-table
      :count="count"
      :list="list"
      :query-list="queryList"
      :is-loading="isLoading"
      :push-list="RouteConfig.youZanSignDateSignedList.push"
      :is-show-search-input="true"
      search-placeholder="输入有赞券码进行搜索"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="150px"/>
    <v-column-avatar label="签到员"/>
    <el-table-column label="有赞券码" prop="ticket_code" width="150px"/>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button @click="RouteConfig.youZanSignDateVerifiedList.push({ keyword: row.ticket_code })" icon="browse" size="large" name="核销记录"/>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`you-zan-sign-date-signed-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>签到员</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>有赞券码</span>
              <span>{{ v.ticket_code }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button @click="RouteConfig.youZanSignDateVerifiedList.push({ keyword: v.ticket_code })" icon="browse" size="large" name="核销记录"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getSignedRecords } from '@/api/you-zan-sign-date';

export default {
  name: RouteConfig.youZanSignDateSignedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getSignedRecords(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
